import React, { useEffect } from 'react';
import GoogleIcon from 'components/ui/icons/GoogleIcon';

/**
 * GoogleAdsFailure Component
 * 
 * Displays an error message when Google Ads OAuth fails.
 * Sends a failure message to the parent window which will close this popup.
 * 
 * Usage: This component is typically rendered in a popup window after failed OAuth.
 */
const GoogleAdsFailure = () => {
  useEffect(() => {
    // Send failure message to parent window
    if (window.opener) {
      window.opener.postMessage({
        type: 'GOOGLE_AUTH_FAILURE',
        timestamp: Date.now()
      }, window.location.origin);
    }
  }, []);

  return (
    <div 
      style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        margin: 0,
        background: 'white',
        color: '#333'
      }}
    >
      {/* Logo */}
      <img 
        src="/ch3.png" 
        alt="Espor.ai" 
        style={{
          height: '60px',
          width: 'auto',
          marginBottom: '2rem'
      }}
      />
      
      <div style={{
        textAlign: 'center',
        padding: '2rem',
        background: '#f8f9fa',
        borderRadius: '12px',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
        border: '2px solid #dc3545'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '1rem',
          position: 'relative'
        }}>
          <GoogleIcon width={48} height={48} />
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '48px',
            height: '48px',
            background: 'rgba(220, 53, 69, 0.1)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{
              width: '2px',
              height: '24px',
              background: '#dc3545',
              transform: 'rotate(45deg)',
              position: 'relative'
            }}>
              <div style={{
                width: '2px',
                height: '24px',
                background: '#dc3545',
                transform: 'rotate(-90deg)',
                position: 'absolute',
                top: '0',
                left: '0'
              }} />
            </div>
          </div>
        </div>
        <h1 style={{
          margin: '0 0 1rem 0',
          fontSize: '1.8rem',
          color: '#dc3545'
        }}>
          Conexión Fallida
        </h1>
        <p style={{
          margin: '0 0 2rem 0',
          opacity: 0.8,
          fontSize: '1rem',
          color: '#6c757d'
        }}>
          No pudimos conectar tu cuenta de Google Ads. Por favor, inténtalo de nuevo.
        </p>
        <div style={{
          fontSize: '0.9rem',
          opacity: 0.6,
          color: '#6c757d'
        }}>
          Esta ventana se cerrará automáticamente...
        </div>
      </div>
    </div>
  );
};

export default GoogleAdsFailure; 